import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/authStore';
import Login from '@/pages/Login';

/**
 * Login Route (/login)
 * 
 * Implements Requirements 6.5, 6.9:
 * - Route-based authentication guards
 * - Programmatic navigation with type-safe paths
 * 
 * Public route for user authentication.
 * Redirects to dashboard if already authenticated.
 */

export const Route = createFileRoute('/login')({
  component: LoginRoute,
});

function LoginRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return <Login />;
}
